<template>
  <div class="fillcontain">
    <search-item @showDialog="showLocationAndCountsDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="locationId"
          label="课程地点"
          align="left"
          :filters="this.courseLocationData"
          :filter-method="filterCourseLocation"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseLocation(scope.row)"
              disable-transitions
              >{{ scope.row.locationId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="max"
          label="上限"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="min"
          label="下限"
          align="center"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditCoursePackage(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoursePackage(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addLocationAndCountsDialog.show"
        :isShow="addLocationAndCountsDialog.show"
        :dialogRow="addLocationAndCountsDialog.dialogRow"
        :courseLocationList="addLocationAndCountsDialog.courseLocationList"
        @getLocationAndCounts="getLocationAndCounts"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getFormatTeachingpoint } from "@/api/teachingpoint";
import {
  getByPageAndLimit,
  deleteLocationAndCounts,
} from "@/api/locationAndCounts";

export default {
  data() {
    return {
      props: { multiple: true, emitPath: false },
      options: [],
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      clockInDialogShow: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addLocationAndCountsDialog: {
        show: false,
        dialogRow: {},
        courseLocationList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      courseLocationData: [],
      format_course_location_list: {},
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatTeachingpoint();
    this.getLocationAndCounts();
  },
  methods: {
    getFormatTeachingpoint() {
      getFormatTeachingpoint().then((res) => {
        this.courseLocationData = res.data.data.courseLocationData;

        var courseLocationList = {
          courseLocationList: this.courseLocationData,
        };
        this.addLocationAndCountsDialog.courseLocationList = courseLocationList;
        this.format_course_location_list =
          res.data.data.formatCourseLocationList;
      });
    },
    filterCourseLocation(value, item) {
      const type = parseInt(item.locationId);
      return (
        this.format_course_location_list[value] ==
        this.format_course_location_list[type]
      );
    },
    formatterCourseLocation(item) {
      const type = parseInt(item.locationId);
      return this.format_course_location_list[type];
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getLocationAndCounts() {
      const para = this.courseData;
      getByPageAndLimit(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.locationAndCounts;
      });
    },
    // 显示添加预约类型弹窗
    showLocationAndCountsDialog(val) {
      this.$store.commit("SET_LOCATION_AND_COUNTS_DIALOG_TITLE", val);
      this.addLocationAndCountsDialog.show = true;
    },
    hideAddFundDialog() {
      this.addLocationAndCountsDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getLocationAndCounts();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getLocationAndCounts();
    },
    // 编辑操作方法
    onEditCoursePackage(row) {
      var param = Object.assign({}, row);
      this.addLocationAndCountsDialog.dialogRow = {
        param,
      };
      this.showLocationAndCountsDialog();
    },
    // 删除数据
    onDeleteCoursePackage(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteLocationAndCounts({ id: row.id }).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getLocationAndCounts();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


